
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import LanguageSwitcher from '../base/LanguageSwitcher';

export default function Header() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              {t('nav_home')}
            </Link>
            <Link to="/rooms" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              {t('nav_rooms')}
            </Link>
            <Link to="/rental-guide" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              {t('nav_rental_guide')}
            </Link>
            <Link to="/life-support" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              {t('nav_life_support')}
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              {t('nav_contact')}
            </Link>
          </nav>

          {/* Language Switcher - Desktop */}
          <div className="hidden md:block">
            <LanguageSwitcher />
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-4 w-full justify-between">
            <LanguageSwitcher />
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link
                to="/"
                className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_home')}
              </Link>
              <Link
                to="/rooms"
                className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_rooms')}
              </Link>
              <Link
                to="/rental-guide"
                className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_rental_guide')}
              </Link>
              <Link
                to="/life-support"
                className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_life_support')}
              </Link>
              <Link
                to="/contact"
                className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_contact')}
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
